/**
 * Cross-cutting constants for the Observ RUM SDK.
 *
 * Kept in a leaf module (no SDK imports beyond semconv constants) so both the
 * public entry point (`index.ts`) and internal modules (`otel-rum.ts`) can share
 * them without a circular import.
 */
import { ATTR_SESSION_ID } from '@opentelemetry/semantic-conventions/incubating'

/**
 * Attribute key used everywhere to correlate signals of a single session.
 * Sourced from the pinned `@opentelemetry/semantic-conventions` (incubating
 * `ATTR_SESSION_ID`) rather than a hand-typed literal, so the key tracks the
 * standard. Enforcement rule (architecture): the OTel session attribute is
 * EXACTLY `session.id` — never `sessionId` nor `session_id`. Single source of
 * truth so every signal (spans, semantic events, rrweb) stamps the identical key.
 * A test asserts `=== 'session.id'` to guard that invariant across semconv bumps.
 */
export const SESSION_ID_ATTRIBUTE: 'session.id' = ATTR_SESSION_ID
